import { render, staticRenderFns } from "./FormBudgetContent.vue?vue&type=template&id=65897761&"
import script from "./FormBudgetContent.vue?vue&type=script&lang=js&"
export * from "./FormBudgetContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports